import { render, staticRenderFns } from "./work-allocation.vue?vue&type=template&id=67d4c529&scoped=true"
import script from "./work-allocation.vue?vue&type=script&lang=js"
export * from "./work-allocation.vue?vue&type=script&lang=js"
import style0 from "./work-allocation.vue?vue&type=style&index=0&id=67d4c529&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d4c529",
  null
  
)

export default component.exports